import { render, staticRenderFns } from "./stationed_user_list.vue?vue&type=template&id=bb85544a"
import script from "./stationed_user_list.vue?vue&type=script&lang=js"
export * from "./stationed_user_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports